// extracted by mini-css-extract-plugin
export var perk = "PerkItem_perk__rlCm5";
export var perkExcluded = "PerkItem_perkExcluded__lvWYc";
export var perkIcon = "PerkItem_perkIcon__LTUQv";
export var perkText = "PerkItem_perkText__hzvGO";
export var plansTooltip = "PerkItem_plansTooltip__IcX3c";
export var plansTooltipShort = "PerkItem_plansTooltipShort__y26WN";